<template>
  <div class="home">

    <div >
            <div>
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0 me-2">{{$t('payments')}}</h4>
                            </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center gap-2">
                            <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="keyword" :placeholder="$t('search')">
                            </div>
                            <button @click="showFilters = !showFilters" class="btn btn-outline-secondary d-md-none">
                                <AppIcon name="bi-funnel" class="bi bi-funnel" />
                            </button>
                        </div>
                    </div>
                    </div>
                </section>
            </div>
      
            <section class="px-8">
                <payment-component
                    :openCreateModal="openCreateModal"
                    :hide-payment-associations="true"
                    :hide-payment-summary="true"
                    @createModalStatus="createModalStatus"
                    :keyword="keyword"
                    :showFilters="showFilters"
                ></payment-component>
            </section>
      </div>

  </div>
</template>

<script>
import PaymentComponent from '../../components/PaymentComponent.vue'
import helper from '../../helper'

export default {
  name: 'Payment',
  persistedFilterState: { key: 'payment-search', fields: ['keyword'] },
  components : {
    PaymentComponent,
  },
  data(){
    return {
        keyword :'',
        payments : [],
        count : 0,
        openCreateModal : false,
        showFilters: false
    }
  },
  mounted(){
    window.mixpanel.track("payment");
    //check permissions
    if(helper.checkAccess('view_payments') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_payments') == -2) return this.$router.push({path : '/subscribe'})

  },
   methods : {
    async create(){
        this.openCreateModal = !this.openCreateModal
    },
    createModalStatus(){}
  },
}
</script>
